import axios from '@/lib/axios-api';
import config from '@/config';

const contextRoot = '/customer-service/v2';

// setup stripe intent

export interface StripeSetupIntent {
  email: string;
  firstName: string;
  lastName: string;
  country: string;
  provinceState: string;
  phone: string;
  address: string;
  postalZip: string;
  city: string;
  memberOptIn: boolean;
  organizationId: string;
}

const apiUrl = config.API_URL;

export const setupStripeIntent = async (paymentIntent: StripeSetupIntent): Promise<string> => {
  const response = await axios.post(`${apiUrl}${contextRoot}/stripe-intent`, paymentIntent);

  if (response.status !== 200) {
    throw new Error(`Error creating Stripe setup intent: ${response.statusText}`);
  }

  return response.data.data.clientSecret;
};
